import { Logo } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

const LandingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 text-center">
      <Logo />
      <h1>{t('page.welcome.title')}</h1>
    </div>
  );
};

export { LandingPage };
